/**
 * Extracts key-value pairs using regex.
 *
 * Supports command strings with illegal whitespacing.
 *
 * Supports multiple values for the same argument.
 *
 * **NOTE:**
 * Each value string must be encased in double quotes, and special characters
 * must be escaped, including double quotes inside the value string.
 */
export const extractKeys = (command, keys) => {
    const json = Object.fromEntries(keys.map((word) => [word, []]));
    keys.forEach((keyword) => {
        const regexp = new RegExp(String.raw `--${keyword}\s+"((?:(?!\s--\w+\s).)*)"`, 'gim');
        const matches = command.matchAll(regexp);
        for (let match of matches) {
            const [, matchedString] = match;
            json[keyword].push(matchedString);
        }
    });
    return json;
};
